---
nb:
  overview:
    48hrs: "(48hr)"
    dir:
      asc: "▼"
      desc: "▲"
    effect_overflow_tip: Sjekk om gjeldende maks produksjonsverdi er riktig for dette kraftverket
    precipitation: Nedbør (48 timers varsel)
    sensor_values:
      above_limit: Over grensen
      below_limit: Under grensen
      within_limits: Innenfor grenser
    sort:
      current_effect: Nåværende Produksjon
      current_income: Inntekt
      name: Navn
      precipitation: Nedbør
      rated_power_mw: Maks kapasitet
      utilization: Utnyttelse
    variants:
      advanced: Avansert kort
      basic: Grunnleggende kort
